<script lang="ts" setup>
const props = defineProps({
  hasBorders: {
    default: true,
    type: Boolean,
  },
  hasEmptyMessage: {
    default: true,
    type: Boolean,
  },
  hasForm: {
    default: true,
    type: Boolean,
  },
  limit: {
    default: Infinity,
    type: Number,
  },
  size: {
    default: 'md',
    type: String as PropType<UInputSize>,
  },
})

const { t } = useI18n()
const localePath = useLocalePath()
const teamsStore = useTeamsStore()

const apiTokensToDisplay = computed(() => {
  return teamsStore.apiTokens.slice(0, props.limit || teamsStore.apiTokens.length)
})

await callOnce(
  'api-tokens',
  async () => {
    if (!teamsStore.apiTokens.length) {
      await teamsStore.fetchTeamApiTokens()
    }
  },
  { mode: 'navigation' },
)
</script>

<template>
  <div
    class="flex flex-col gap-4 text-left"
    :class="{ 'gradient-texture-reverse rounded-xl bg-gray-100 p-4 shadow ring-1 ring-gray-200 md:p-6 dark:bg-gray-900 dark:ring-gray-800': hasBorders }"
  >
    <ApiTokensBoxForm
      v-if="hasForm"
      :size="teamsStore.apiTokens.length ? 'md' : size"
    />

    <template v-if="teamsStore.apiTokens.length">
      <ApiTokensBoxItem
        v-for="apiToken in apiTokensToDisplay"
        :key="apiToken.id"
        :api-token="apiToken"
      />

      <UButton
        v-if="teamsStore.apiTokens.length > limit"
        block
        :label="t('showAllTokens')"
        :to="localePath('settings-api-tokens')"
      />
    </template>

    <BaseMessage
      v-else-if="hasEmptyMessage"
      :description="t('empty.description')"
      size="xs"
      :title="t('empty.title')"
    />
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "empty": {
      "description": "Create an API token to start using our endpoints.",
      "title": "No API token found"
    },
    "showAllTokens": "Show all tokens"
  },
  "es": {
    "empty": {
      "description": "Crea un token API para empezar a usar nuestros endpoints.",
      "title": "No se encontró ningún token API"
    },
    "showAllTokens": "Mostrar todos los tokens"
  },
  "fr": {
    "empty": {
      "description": "Créez un token API pour commencer à utiliser nos endpoints.",
      "title": "Aucun token API trouvé"
    },
    "showAllTokens": "Afficher tous les tokens"
  }
}
</i18n>
